export default {"src":"/_next/static/media/shocked.62f6916c.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};